const { FORGOT_PASSWORD_URL } = require('../helper/application-conf').default;

const constructEndpoint = (url: string, siteName: string, email: string) => {
  return `${url}?email=${email}&sitename=${siteName}&isDAO=true&isEnrollment=true`;
};

const handleForgotPasswordRequest = (siteName: string, emailId: string, axiosSecurity: any) => {
  const endpoint = constructEndpoint(FORGOT_PASSWORD_URL, siteName, emailId);
  const response = axiosSecurity.post(endpoint,
    {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    }
  );
  return response;
};

export default handleForgotPasswordRequest;
